<template>
  <div class="admin-page">
    <div class="admin-toolbar">
      <div class="admin-toolbar__actions">
        <el-input v-model="filters.couponNo" placeholder="券号" clearable class="filter-input" @keyup.enter="fetchList" />
        <el-input v-model="filters.ownerUserId" placeholder="推荐人用户ID" clearable class="filter-input" @keyup.enter="fetchList" />
        <el-select v-model="filters.couponType" placeholder="类型" clearable class="filter-select" @change="fetchList">
          <el-option label="双享礼券" value="normal" />
          <el-option label="臻享礼券" value="partner" />
          <el-option label="专享礼券" value="cash" />
        </el-select>
        <el-select v-model="filters.status" placeholder="状态" clearable class="filter-select" @change="fetchList">
          <el-option label="可用" value="active" />
          <el-option label="已使用" value="used" />
        </el-select>
        <el-button type="primary" @click="fetchList">查询</el-button>
      </div>
    </div>

    <el-table :data="coupons" v-loading="loading" style="width: 100%">
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="couponNo" label="券号" width="130" />
      <el-table-column prop="displayName" label="名称" min-width="120" />
      <el-table-column label="推荐人" min-width="140">
        <template #default="scope">
          {{ scope.row.ownerNickname || scope.row.ownerUsername }}
          <div class="muted">ID: {{ scope.row.ownerUserId }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="couponType" label="类型" width="120">
        <template #default="scope">{{ couponTypeLabel(scope.row.couponType) }}</template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80" />
      <el-table-column label="绑定用户" width="100">
        <template #default="scope">{{ scope.row.usedByUserId || '—' }}</template>
      </el-table-column>
    </el-table>

    <AdminPagination
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :total="total"
      @size-change="fetchList"
      @current-change="fetchList"
    />
  </div>
</template>

<script>
import axios from 'axios'
import AdminPagination from '@/components/AdminPagination.vue'
import { couponTypeLabel } from '@/utils/referralCoupon'

export default {
  name: 'ReferralCouponManagement',
  components: { AdminPagination },
  data() {
    return {
      loading: false,
      coupons: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filters: { couponNo: '', ownerUserId: '', couponType: '', status: '' }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    couponTypeLabel,
    async fetchList() {
      this.loading = true
      try {
        const ownerUserId = this.filters.ownerUserId ? Number(this.filters.ownerUserId) : 0
        const res = await axios.post('/api/v1/admin/referral/coupon/list', {
          page: this.currentPage,
          pageSize: this.pageSize,
          couponNo: this.filters.couponNo || undefined,
          ownerUserId,
          couponType: this.filters.couponType || undefined,
          status: this.filters.status || undefined
        })
        if (res.data.code !== 200) {
          this.$message.error(res.data.message || '加载失败')
          return
        }
        this.coupons = res.data.data?.coupons || []
        this.total = res.data.data?.total || 0
      } catch (e) {
        this.$message.error(e.response?.data?.message || '加载失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.muted { font-size: 12px; color: #909399; }
</style>
